import { useState } from "react";
import { accountMessage } from "../account/messages";
import type { ShopActions, ShopView } from "./view-model";

/** "Have a code?" in the Shop: a promo code from the owner gives an item for free (docs/plans/015-admin-analytics.md). */
export function PromoCode({ shop, shopActions }: { shop: ShopView; shopActions?: ShopActions }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  if (!shop.signedIn || !shopActions?.onRedeem) return null;
  const itemName = shop.gift ? shop.items.find((i) => i.id === shop.gift)?.name : null;

  if (!open) {
    return (
      <div style={{ textAlign: "center" }}>
        <button type="button" className="link-btn" data-testid="promo-open" onClick={() => setOpen(true)}>
          Have a code?
        </button>
      </div>
    );
  }
  return (
    <form
      data-testid="promo-form"
      style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr)", gap: "8px" }}
      onSubmit={(e) => {
        e.preventDefault();
        if (code.trim() && !shop.busy) void shopActions.onRedeem?.(code);
      }}
    >
      <label htmlFor="promo-code">Your code</label>
      <div className="fi">
        <input
          id="promo-code"
          data-testid="promo-code"
          type="text"
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck={false}
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </div>
      {shop.gift ? (
        <div className="note" role="status" data-testid="promo-gift">
          {`It worked! ${itemName ?? "Your gift"} is yours now.`}
        </div>
      ) : shop.problem ? (
        <div className="note" role="alert" data-testid="promo-problem">
          {shop.problem === "bad_code" ? "That code does not work." : accountMessage(shop.problem)}
        </div>
      ) : null}
      <button type="submit" className="btn" data-testid="promo-submit" disabled={shop.busy || !code.trim()}>
        Use code
      </button>
    </form>
  );
}
